module.exports = __webpack_public_path__ + "img/3-01-02-safety-check.f59c9ec2.svg";